import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

export interface AnswerHintDto {
  id: number;
  answerId: number;
  checked: boolean;
  hintText?: string;
  isDeleted: boolean;
  isEnabled: boolean;
}

export interface AnswerHintCreateDto {
  answerId: number;
  checked: boolean;
  hintText?: string;
}

export interface AnswerHintUpdateDto {
  checked: boolean;
  hintText?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AnswerHintService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = '/api/answerhints';

  getByAnswerId(answerId: number): Observable<AnswerHintDto> {
    return this.http.get<AnswerHintDto>(`${this.apiUrl}/${answerId}`);
  }

  getByQuestionId(questionId: number): Observable<AnswerHintDto[]> {
    return this.http.get<AnswerHintDto[]>(`${this.apiUrl}/question/${questionId}`);
  }

  create(data: AnswerHintCreateDto): Observable<AnswerHintDto> {
    return this.http.post<AnswerHintDto>(this.apiUrl, data);
  }

  update(id: number, data: AnswerHintUpdateDto): Observable<AnswerHintDto> {
    return this.http.put<AnswerHintDto>(`${this.apiUrl}/${id}`, data);
  }
}
